import React from 'react'
import UserSearch from './UserSearch'
import RoomManaging from './RoomManaging'

const StudentCouncil: React.FC = () => {
  return (
    <div style={{ padding: 16, boxSizing: 'border-box', width: '100%' }}>
      <RoomManaging />
      <UserSearch />
    </div>
  );
};

export default StudentCouncil;
